var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseDialog',{attrs:{"title":"會員資料同步確認","btn1":"確認同步","btn2":"取消","btn1Loading":_vm.loading,"append-to-body":""},on:{"close":_vm.handleClose,"confirm":_vm.handleConfirm}},[_c('span',[_vm._v("系統將同步提供資料至"+_vm._s(_vm.shopName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }